import React from 'react';

const Container = ({children, ...rest}) => {
  return (
    <main { ...rest }>
      { children }
    </main>
  )
}

export default Container;
